import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import RichTextEditor from "../../../components/form/RichTextEditor";
import Select from "../../../components/form/select/Select";
import PageTitle from "../../../components/partials/PageTitle";
import {
  getAllActivePolicies,
  getAllActiveSavingsPolicies,
} from "../../../redux/slice/policy/policySlice";
import {
  createClause,
  resetClausesStatus,
} from "../../../redux/slice/clauses/clauseSlice";
import { policyCategories } from "../../../utils/data/constant";

const AddClause = () => {
  const { user } = useSelector((state) => state.auth?.user);
  const { active_policy, isLoading } = useSelector((state) => state.policy);
  const { createSuccess } = useSelector((state) => state.clause);
  const { user_permissions } = useSelector((state) => state?.auth?.user);

  const [policyData, setPolicyData] = useState([]);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const policySelectRef = useRef();

  const breadcrumb = {
    from: {
      title: "settings",
      link: "/admin/settings",
    },
    current: {
      title: "preloaded clauses",
      link: null,
    },
  };

  const policyCat = policyCategories?.map((cat, index) => ({
    label: cat.title,
    value: index + 1,
  }));

  const validationScehma = Yup.object().shape({
    clause_name: Yup.string("Clause Title must be a string").required(
      "Clause Title cannot be blank"
    ),
    policy_id: Yup.number("Policy Id must be a number").required(
      "Policy is required"
    ),
  });

  const onSubmit = (values) => {
    const payload = { ...values };
    dispatch(createClause(payload));
  };

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      clause_name: "",
      description: "",
      policy_id: "",
      policy_category: 1,
    },
    validationSchema: validationScehma,
    onSubmit,
    validate: (values) => {
      const errors = {};

      if (!values.description.trim()) {
        errors.description = "description is required";
      } else if (!hasEmptyTags(values.description)) {
        errors.description = "Tags cannot be empty";
      }

      return errors;
    },
  });

  const hasEmptyTags = (content) => {
    const regex = /<[^>]+>([^<]+)<\/[^>]+>/g;
    return regex.test(content);
  };

  const handleContentChange = (newContent) => {
    setFieldValue("description", newContent, true);
  };

  useEffect(() => {
    if (values.policy_category === 1) {
      dispatch(getAllActivePolicies({ office_id: parseInt(user?.office_id) }));
    }
    if (values.policy_category === 2) {
      dispatch(
        getAllActiveSavingsPolicies({ office_id: parseInt(user?.office_id) })
      );
    }
  }, [values.policy_category, user?.office_id]);

  useEffect(() => {
    const policyData = active_policy?.policy
      ?.filter((item) => item.policy_cat_id === String(values.policy_category))
      .map((policy) => {
        return {
          label: policy.name,
          value: policy.id,
        };
      });
    setPolicyData(policyData);
  }, [active_policy]);

  useEffect(() => {
    if (createSuccess) {
      if (values.policy_category === 1) {
        navigate("/admin/settings/preloaded-clauses");
      } else if (values.policy_category === 2) {
        navigate("/admin/settings/preloaded-savings-clauses");
      }
      dispatch(resetClausesStatus());
    }
  }, [createSuccess, dispatch, navigate, values.policy_category]);

  useEffect(() => {
    if (
      !user_permissions?.some(
        (permission) => permission.name === "settings module"
      ) ||
      !user_permissions?.some(
        (permission) => permission.name === "clause module"
      ) ||
      !user_permissions?.some((permission) => permission.name === "add clause")
    ) {
      navigate("/admin/dashboard");
    }
  }, [navigate, user_permissions]);

  return (
    <>
      {/* page title */}
      <PageTitle title='Preloaded Clauses' breadcrumb={breadcrumb} />
      {/* end page title */}

      <div className='row'>
        <div className='col-md-12'>
          <div className='card'>
            <div className='card-body'>
              <form onSubmit={handleSubmit}>
                <div className='row pb-2 mb-3 text-capitalize border-bottom'>
                  <div className='col-md-12 d-flex justify-content-between align-items-center'>
                    <h4 className='header-title text-uppercase mb-0 text-primary '>
                      Add Clause
                    </h4>
                    <span
                      onClick={() => navigate(-1)}
                      className='btn btn-primary btn-sm float-end '
                    >
                      Go Back
                    </span>
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-md-3 col-lg-2 text-right sm-text-end'>
                    <label htmlFor='clause_name' className='col-form-label'>
                      Clause Title
                      <span className='text-danger'> *</span>
                    </label>
                  </div>
                  <div class='col-sm-6'>
                    <input
                      type='text'
                      className='form-control form-control-sm'
                      id='clause_name'
                      value={values?.clause_name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors?.clause_name && touched?.clause_name && (
                      <p className='mb-0 text-danger'>
                        {errors?.clause_name + "*"}
                      </p>
                    )}
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-md-3 col-lg-2 text-end sm-text-end'>
                    <label htmlFor='account_type' className={`form-label mt-1`}>
                      Policy Category <span className='text-danger'>*</span>
                    </label>
                  </div>

                  <div className='col-sm-6'>
                    <Select
                      name='policy_category'
                      data={policyCat}
                      value={parseInt(values?.policy_category)}
                      onChange={(selectedOption) => {
                        setFieldValue("policy_category", selectedOption?.value);
                        setPolicyData([]);
                        setFieldValue("policy_id", "");
                        policySelectRef.current.clearValue();
                      }}
                    />
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-md-3 col-lg-2 text-end sm-text-end'>
                    <label htmlFor='account_type' className={`form-label mt-1`}>
                      Policy Target <span className='text-danger'>*</span>
                    </label>
                  </div>

                  <div className='col-sm-6'>
                    <Select
                      onBlur={() => {
                        handleBlur({ target: { name: "policy_id" } });
                      }}
                      name='policy_id'
                      ref={policySelectRef}
                      data={policyData}
                      value={parseInt(values?.policy_id)}
                      onChange={(selectedOption) =>
                        setFieldValue("policy_id", selectedOption?.value)
                      }
                      isLoading={isLoading}
                    />
                    {errors?.policy_id &&
                      touched?.policy_id &&
                      !values.policy_id && (
                        <p className='mb-0 text-danger'>
                          {errors?.policy_id + "*"}
                        </p>
                      )}
                  </div>
                </div>
                <div className='row mb-5'>
                  <div className='col-md-3 col-lg-2 text-end sm-text-end'>
                    <label htmlFor='account_type' className={`form-label mt-1`}>
                      Description<span className='text-danger'>*</span>
                    </label>
                  </div>

                  <div className='col-sm-6'>
                    <RichTextEditor
                      name='description'
                      id='description'
                      onBlur={() => {
                        handleBlur({ target: { name: "description" } });
                      }}
                      value={values.description}
                      onChange={handleContentChange}
                    />
                    {errors?.description && touched?.description && (
                      <p className='mb-0 text-danger'>
                        {errors?.description + "*"}
                      </p>
                    )}
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-sm-2'></div>
                  <div className='col-sm-6'>
                    <button
                      type='submit'
                      className='btn btn-primary btn-md px-4 rounded'
                    >
                      Create
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddClause;
